import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import FileProcessingApiHandler from 'app/services/fileProcessingApiHandler';

export interface DownloadFileRequest {
  fileId: string;
  fileName: string;
}

const useDownloadFile = (options?: UseMutationOptions<string, Error, DownloadFileRequest>) => {
  return useMutation<string, Error, DownloadFileRequest>({
    mutationFn: async ({ fileId, fileName }) => {
      const response = await FileProcessingApiHandler.getFileDownloadUrl(fileId, fileName);

      // If the response contains a url property, return it
      if (response && typeof response === 'object' && 'url' in response) {
        const downloadUrl = (response as { url: string }).url;
        return downloadUrl;
      }

      // If the response contains a downloadUrl property, return it
      if (response && typeof response === 'object' && 'downloadUrl' in response) {
        const { downloadUrl } = response as { downloadUrl: string };
        return downloadUrl;
      }

      // If the response is a string URL, return it directly
      if (typeof response === 'string') {
        return response;
      }

      throw new Error('Invalid download response format');
    },
    ...options,
  });
};

export default useDownloadFile;
